<style lang="less" scoped></style>
<template>
  <div>
    <Content
      class="content-head"
      :style="{
        margin: 0,
        padding: '30px 0 30px 30px',
        height: 'auto',
      }"
    >
      <h1 class="content-head-title">ストレージ</h1>
      <UserName class="content-head-username"></UserName>
    </Content>
    <div class="content-layout">
      <Content
        :style="{
          margin: 0,
          padding: '20px',
          height: 'auto',
        }"
      >
        <StorageFileDetail :id="id"></StorageFileDetail>
      </Content>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Content } from "@/generic";
import UserName from "@/shared/components/CurrentUserName.vue";

import StorageFileDetail from "@/client/components/settings/storageFile/Detail.vue";

export default defineComponent({
  components: {
    Content,
    StorageFileDetail,
    UserName,
  },
  props: {
    id: {
      type: String,
      requred: true,
    },
  },
});
</script>
